// extracted by mini-css-extract-plugin
module.exports = {"slideDirectionButton":"_3HriI","slideBackwardButton":"WtJgQ _3HriI","slideForwardButton":"_3HrsB _3HriI","icon":"_2yKrK","forwardIcon":"_3PBxt _2yKrK"};